import RegistrationSuccessComp from '../../components/portal/RegistrationSuccess';

const RegistrationSuccess = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <RegistrationSuccessComp />
    </div>
  );
};

export default RegistrationSuccess; 